import { client } from '../../../../../common-utils/libraries/axios/axios';
import CONNECTION from '../apiUrls';

const mutationPostLogout = (onSuccess, onError) => {
    return {
        mutationFn: () => {
            return client.post(CONNECTION.LOGOUT.url);
        },
        // onError: (error, variables, context)
        onError: () => {
            onError();
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationPostLogout;